import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { i18n } from '@/plugins/i18n';
import '@/plugins/buefy';
import '@/plugins/vue-infinite-loading';
import '@/plugins/vue-gtm';
import '@/plugins/sentry';
import '@/plugins/custom-icons';
import VConsole from 'vconsole';

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
  new VConsole();
}

new Vue({
  router,
  data: () => ({
    surveyUrl: '', // 会員情報設定サーベイ
  }),
  i18n,
  render: h => h(App),
}).$mount('#app');

// JavaScript error handling
window.onerror = (_message, _source, _lineno, _colno, error) => {
  console.error(error);
  return true;
};
